module.exports = __webpack_public_path__ + "img/GAMEBOOKERS.0dc84bee.svg";